import Moment from 'moment';
import {hasTimeLocking, hasTimeApproval} from '../../../forecast-app/shared/util/FeatureUtil';

// `person` is optional; when provided, a person-level exclusion suppresses the company lock for
// that person. Existing single-arg callers (no person in scope) keep applying the company lock
// unconditionally, since `undefined?.excludeFromCompanyLockedPeriod` is falsy.
export const getCompanyLockedDate = (company, person) => {
	if (hasTimeLocking(company.modules)) {
		return (
			!person?.excludeFromCompanyLockedPeriod &&
			company.lockedPeriodYear &&
			Moment({y: company.lockedPeriodYear, M: company.lockedPeriodMonth - 1, d: company.lockedPeriodDay})
		);
	}
};

export const getLockedDate = (company, person) => {
	if (hasTimeLocking(company.modules)) {
		const companyLockDate = getCompanyLockedDate(company, person);
		if (hasTimeApproval(company.modules)) {
			const personLockDate =
				person?.submitLockedDateYear &&
				Moment({y: person.submitLockedDateYear, M: person.submitLockedDateMonth - 1, d: person.submitLockedDateDay});
			if (!personLockDate && !companyLockDate) return undefined;
			if (!personLockDate || !companyLockDate) return personLockDate || companyLockDate;

			return personLockDate.isAfter(companyLockDate) ? personLockDate : companyLockDate;
		}

		return companyLockDate;
	}
};
